exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".review-content {\n  margin-top: 50px; }\n  .review-content button {\n    background: #572f76;\n    border: none;\n    color: #fff;\n    text-transform: uppercase;\n    font-size: 14px;\n    padding: 10px 20px;\n    cursor: pointer;\n    border-radius: 20px;\n    margin-top: 20px;\n    width: auto;\n    height: auto; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /var/lib/jenkins/workspace/landing_page/src/app/components/provide-product-detail/provide-product-detail.component.scss
// module id = ../../../../../src/app/components/provide-product-detail/provide-product-detail.component.scss
// module chunks = main